import { RadioGroup, RadioGroupIndicator } from "~/components/ui/radio-group";
import { stripMarkdownToText } from "~/lib/stripMarkdownToText";
import { AgentAvatar, type AgentAvatarInput } from "./AgentAvatar";

// The minimal agent shape the roster list needs. A full `Agent` — from the
// new-session splash and the in-session switcher alike — satisfies it
// structurally, so one list renders either. The avatar fields ride along from
// `AgentAvatarInput`, so each row shows the agent's avatar.
export interface AgentPickListItem extends Partial<AgentAvatarInput> {
  id: string;
  display_name: string;
  description?: string | null;
}

interface AgentPickListProps {
  agents: AgentPickListItem[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

// The single-select agent roster shared by the new-session splash and the
// in-session switcher, so the list renders and behaves one way everywhere.
export const AgentPickList = ({ agents, selectedId, onSelect }: AgentPickListProps) => (
  <RadioGroup value={selectedId ?? ""} onValueChange={onSelect} className="block">
    <ul className="max-h-80 divide-y divide-border overflow-y-auto rounded-lg">
      {agents.map((agent) => (
        <li key={agent.id}>
          <label className="flex cursor-pointer items-center gap-3 px-4 py-3 transition-colors hover:bg-accent/50">
            <RadioGroupIndicator value={agent.id} />
            <AgentAvatar agent={agent} size={32} />
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-foreground">{agent.display_name}</p>
              {agent.description && (
                <p className="truncate text-xs text-muted-foreground">
                  {stripMarkdownToText(agent.description)}
                </p>
              )}
            </div>
          </label>
        </li>
      ))}
    </ul>
  </RadioGroup>
);
